import templateUrl from "./register.html";

export const registerComponent = {
  templateUrl,
  controller: class RegisterComponent {
    constructor($state, AuthService, $location, toastr, ApiService) {
      "ngInject";

      this.$state = $state;
      this.authService = AuthService;
      this.toastr = toastr;
      this.apiService = ApiService;
      this.$location = $location;
      this.email = "";
      this.lastName = "";
      this.password = "";
      this.firstName = "";
      this.phoneNumber = "";
      this.militaryEmail = "";
      this.nameOfCommand = "";
      this.confirmPassword = "";
      this.phoneCountryCode = null;
      this.unitIdentificationCode = "";
    }

    $onInit() {
      this.disableButtons = false;
      this.source = this.$location.search().source;
      if (!this.source) {
        this.$state.go("login");
      }
      if (this.authService.isAuthenticated()) {
        this.$state.go("home");
      }
      this.phoneNumberDetails = {
        phoneNumber: "",
        phoneDialCode: "+1",
        phoneCountryCode: "US",
      };
    }

    getLocationDetails(details) {
      this.location = details;
    }

    onPhoneNumberUpdate({ phoneNumber, phoneDialCode, phoneCountryCode }) {
      this.phoneNumberDetails = {
        phoneNumber,
        phoneDialCode,
        phoneCountryCode,
      };
    }

    setRegisterDetails() {
      const details = {
        email: this.email,
        source: this.source,
        password: this.password,
        firstName: this.firstName,
        militaryEmail: this.militaryEmail,
        nameOfCommand: this.nameOfCommand,
        unitIdentificationCode: this.unitIdentificationCode,
      };
      if (this.lastName) {
        details.lastName = this.lastName;
      }
      if (this.phoneNumberDetails.phoneNumber) {
        details.phoneNumber = this.phoneNumberDetails.phoneNumber;
        details.phoneCountryCode = this.phoneNumberDetails.phoneCountryCode;
        details.phoneDialCode = this.phoneNumberDetails.phoneDialCode;
      }
      return details;
    }

    register() {
      const registerDetails = this.setRegisterDetails();
      if (this.password === this.confirmPassword) {
        this.disableButtons = true;
        this.authService
          .register(registerDetails)
          .then(() => {
            this.disableButtons = false;
            this.toastr.success("Registered successfully");
            this.$state.go("login");
          })
          .catch(({ data }) => {
            this.disableButtons = false;
            this.toastr.error(data.errors.message);
          });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/auth/register/register.component.js